import { createFileRoute } from '@tanstack/react-router';

// Route-tree registration for /api/ping. The actual response is produced in
// `src/server-entry.ts`, which intercepts /api/ping before Tanstack Start's
// fetch handler runs — see `src/_shared/api/ping/handler.ts`. This file
// exists so the URL is "known" to the router; under normal operation its
// component is never rendered because the server-entry short-circuit returns
// JSON before reaching here.

export const Route = createFileRoute('/api/ping')({
	component: () => null,
});
